export const _setObject = payload => ({
    type: 'SET_OBJECT',
    payload
})